export const parseSizeValue = (value: string | number): string => {
  const suffix =
    typeof value === 'number' || String(parseInt(value as string, 10)) === value ? 'px' : ''

  return value + suffix
}
